import userIcon from "../../../assets/user_icon.png";

import styles from "./UserInfo.module.css";

const UserInfo = (props) => {
  const accountDetails = props.accountDetails;
  console.log("accountDetails: ", accountDetails);
  return (
    <div
      className={`d-flex flex-column`}
    >
      <p className="fw-bold">Welcome {accountDetails.displayName}</p>
      <div className="d-flex">
        <img
          src={userIcon}
          className={`${styles.userIcon}`}
          alt="nexi-group"
        />
        <ul>
          <li><span className="fst-italic">{accountDetails && accountDetails.id}</span></li>
          {accountDetails.office && <li><span className="fst-italic">{accountDetails.office}</span></li>}
          <li><span className="fst-italic">{accountDetails.company}</span></li>
        </ul>
      </div>
    </div>
  );
};

export default UserInfo;
